import { render, staticRenderFns } from "./ui-form.vue?vue&type=template&id=6f7739c4&scoped=true&"
import script from "./ui-form.vue?vue&type=script&lang=js&"
export * from "./ui-form.vue?vue&type=script&lang=js&"
import style1 from "./ui-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7739c4",
  null
  
)

export default component.exports